module.exports = __webpack_public_path__ + "img/code2.ff577eaf.png";